import { render, staticRenderFns } from "./medicalRobots.vue?vue&type=template&id=7c178228&scoped=true&"
import script from "./medicalRobots.vue?vue&type=script&lang=js&"
export * from "./medicalRobots.vue?vue&type=script&lang=js&"
import style0 from "./medicalRobots.vue?vue&type=style&index=0&id=7c178228&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c178228",
  null
  
)

export default component.exports